module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.illustration) ? _c('div', {
    staticClass: "admin-illustration"
  }, [_c('navbar'), _vm._v(" "), _c('h2', [_vm._v("Edit Illustration \"" + _vm._s(_vm.illustration.Subject) + "\"")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-md-6"
  }, [_c('p'), _vm._v(" "), _c('h5', [_vm._v("Subject")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Subject"
    },
    model: {
      value: (_vm.illustration.Subject),
      callback: function($$v) {
        _vm.$set(_vm.illustration, "Subject", $$v)
      },
      expression: "illustration.Subject"
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('h5', [_vm._v("Slug")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Slug"
    },
    model: {
      value: (_vm.illustration.Slug),
      callback: function($$v) {
        _vm.$set(_vm.illustration, "Slug", $$v)
      },
      expression: "illustration.Slug"
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('h5', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "textarea": "",
      "placeholder": "Remarks"
    },
    model: {
      value: (_vm.illustration.Remarks),
      callback: function($$v) {
        _vm.$set(_vm.illustration, "Remarks", $$v)
      },
      expression: "illustration.Remarks"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "col-md-6"
  }, [_c('p'), _vm._v(" "), _c('h5', [_vm._v("Shape")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.illustration.ShapeId),
      expression: "illustration.ShapeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.illustration, "ShapeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.shapes), function(s) {
    return _c('option', {
      domProps: {
        "value": s.Key
      }
    }, [_vm._v(_vm._s(s.Value))])
  })), _vm._v(" "), _c('p'), _vm._v(" "), _c('h5', [_vm._v("Composition Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.illustration.CompositionTypeId),
      expression: "illustration.CompositionTypeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.illustration, "CompositionTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.shapes), function(s) {
    return _c('option', {
      domProps: {
        "value": s.Key
      }
    }, [_vm._v(_vm._s(s.Value))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-md-12"
  }, [_c('p'), _vm._v(" "), _c('h5', [_vm._v("Icon Classes")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "Add this as new tag",
      "placeholder": "Search or add a tag",
      "label": "Value",
      "track-by": "Key",
      "options": _vm.iconclasses,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.illustration.IconClasses.Items),
      callback: function($$v) {
        _vm.$set(_vm.illustration.IconClasses, "Items", $$v)
      },
      expression: "illustration.IconClasses.Items"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-md-12"
  }, [_c('p'), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("Opslaan, Juffie")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Annuleren")])], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aa350d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/admin-illustration.vue
// module id = 241
// module chunks = 1